import { GetNotificationResponse } from '@pushly/models/lib/structs/notifications'
import { OrgNotificationModel } from '../../../models/notification/org-notification.model'
import { getDefaultNotificationActions } from '../../../_utils/domain'
import { INotificationAction } from '../../../interfaces/notification-action'
import { parseNotificationResponse } from '../../notifications/helpers/notification-helpers'

export const convertOrgNotificationModelToGetNotificationResponse = (
    model: OrgNotificationModel,
): GetNotificationResponse | undefined => {
    let dto: GetNotificationResponse | undefined

    if (model.getId()) {
        try {
            const variant = model.getVariant()
            const audience = variant?.getAudience()
            const content = variant?.getContent()
            const defaultContent = content?.getDefaultContent()
            const webContent = content?.getWebContent()
            const nativeIosContent = content?.getNativeIosContent()
            const expOpts = defaultContent?.getExperienceOptions()
            const delivery = variant?.getDelivery()

            // TODO: getDefaultNotificationActions returns camelCase INotificationAction[],
            // but plainToInstance expects snake_case. The fallback actions likely get silently dropped.
            let actions: Array<Record<string, unknown> | INotificationAction> | undefined = defaultContent
                ?.getActions()
                ?.map((action) => ({
                    id: action.getId(),
                    ordinal: action.getOrdinal(),
                    type: action.getType(),
                    label: action.getLabel(),
                    landing_url: action.getLandingUrl(),
                    use_primary_landing_url: action.getUsePrimaryLandingUrl(),
                }))

            if (defaultContent?.getCustomActionsEnabled() && (actions?.length ?? 0) === 0) {
                actions = getDefaultNotificationActions(null)
            }

            const raw: Record<string, unknown> = {
                id: String(model.getId()),
                audience: {
                    domain_ids: audience?.getDomainIds(),
                    segment_ids: audience?.getSegmentIds(),
                    excluded_segment_ids: audience?.getExcludedSegmentIds(),
                },
                template: {
                    keywords: defaultContent?.getKeywords(),
                    channels: {
                        default: {
                            landing_url: defaultContent?.getLandingUrl(),
                            title: defaultContent?.getTitle(),
                            body: defaultContent?.getBody(),
                            image_url: defaultContent?.getImageUrl(),
                            icon_url: defaultContent?.getIconUrl(),
                            is_using_domain_default_icon: defaultContent?.getIsUsingDomainDefaultIcon(),
                            badge_url: defaultContent?.getBadgeUrl(),
                            is_using_domain_default_badge: defaultContent?.getIsUsingDomainDefaultBadge(),
                            override_default_actions: defaultContent?.getCustomActionsEnabled(),
                            actions,
                            is_silent: expOpts?.getIsSilent(),
                            require_interaction: expOpts?.getRequireInteraction(),
                            keywords: defaultContent?.getKeywords(),
                        },
                        web: {
                            title: webContent?.getTitle(),
                            body: webContent?.getBody(),
                            landing_url: webContent?.getLandingUrl(),
                            image_url: webContent?.getImageUrl(),
                            icon_url: webContent?.getIconUrl(),
                        },
                        native_ios: {
                            category: nativeIosContent?.getCategory(),
                            subtitle: nativeIosContent?.getSubtitle(),
                            sound: nativeIosContent?.getSound(),
                            interruption_level: nativeIosContent?.getInterruptionLevel(),
                            relevance_score: nativeIosContent?.getRelevance(),
                            badge_behavior: nativeIosContent?.getBadgeBehavior(),
                            target_content_id: nativeIosContent?.getTargetContentId(),
                        },
                    },
                },
                delivery_spec: {
                    type: delivery?.getType(),
                    window: delivery?.getWindow(),
                    timezone: delivery?.getTimeZone(),
                    send_date_utc: delivery?.getSendDate(),
                    ttl_seconds: expOpts?.getTtlSeconds(),
                    ttl_metric: expOpts?.getTtlMetric(),
                },
                channels: variant?.getChannels(),
                collapse_key: expOpts?.getCollapseKey() ?? undefined,
            }

            dto = parseNotificationResponse(raw)
        } catch (_) {}
    }

    return dto
}
